// extracted by mini-css-extract-plugin
export default {"signUpForm":"SignUpForm_signUpForm__db0Dt","lastInput":"SignUpForm_lastInput__mESHU","button":"SignUpForm_button__P1irC","secondaryButton":"SignUpForm_secondaryButton__QPHmb"};